import TuleButton from "../../../../../common/components/atom/TuleButton.tsx/TuleButton";
import ModalDrawer from "../../../../../common/components/organisme/ModalDrawer/ModalDrawer";
import useQueryURL from "../../../../../common/hooks/useQueryURL";
import PayGoFormPresenter from "../PayGoForm/PayGoFormPresenter";
import PaygGoImage from "../../../../../assets/coin.png";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";
const MODAL_ID_DEFAULT = "new-paygo-modal";

export const CreateNewPayGoBtn = ({
  modalId = MODAL_ID_DEFAULT,
  goToCreateNewPayGoMode,
}: {
  modalId?: string;
  goToCreateNewPayGoMode?: boolean;
}) => {
  const { setQueryValue } = useQueryURL();
  const navigateApp = useNavigationApp();
  const { userRole } = useAuth();
  if (!userRole || userRole < userRoles.ADMIN) {
    return <></>;
  }
  const onClick = () => {
    if (goToCreateNewPayGoMode) {
      navigateApp.goToNewPayGo();
      return;
    }
    setQueryValue({ [modalId]: "true" });
  };

  return (
    <TuleButton
      label="Créer un nouveau PayGo"
      onClick={onClick}
      color={{
        text: "white",
        background: "#042536",
        border: "#3684A650",
      }}
      ImageRender={() => <PayGoImage />}
    />
  );
};

export const NewPayGoModal = ({
  modalId = MODAL_ID_DEFAULT,
}: {
  modalId: string;
}) => {
  return (
    <ModalDrawer title="Créer un nouveau PayGo" urlParamName={modalId}>
      <PayGoFormPresenter />
    </ModalDrawer>
  );
};

const PayGoImage = () => {
  return (
    <img
      style={{
        width: "100%",
        height: "70%",

        marginLeft: "40%",
        marginTop: "25%",
        scale: "1.5",
        objectFit: "contain",
      }}
      src={PaygGoImage}
      alt="Borne"
    />
  );
};

export default function CreateNewPayGoBtnModal({
  modalId = MODAL_ID_DEFAULT,
}: {
  modalId?: string;
}) {
  return (
    <>
      <CreateNewPayGoBtn modalId={modalId} />
      <NewPayGoModal modalId={modalId} />
    </>
  );
}
